export const parseDate = (date) => {
  if (!date) return 0;

  try {
    // убираем микросекунды до миллисекунд
    const normalized = date.replace(
      /(\.\d{3})\d+/,
      "$1"
    ).replace(" ", "T");
    const cdate = new Date(normalized)
    
    return {
      cdate: cdate.toISOString().slice(0, 10),
      ctimestamp: cdate.getTime()
    }
  }
  catch (parseDate_error) {
    console.log({parseDate_error});
    
    return {
      cdate: "0-0-0",
      ctimestamp: 0
    }
  }
};
